import styled, { css } from 'styled-components';

export const CardWrapper = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    border-radius: 20px;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: space-between;
    min-height: 290px;
    overflow: hidden;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      min-height: auto;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      min-width: 228px;
      width: 100%;
    }
  `}
`;

export const CardContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
    position: relative;
    width: 50%;

    @media (max-width: 1640px) {
      width: 65%;
    }

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      padding: 12px;
      gap: 12px;
    }
  `}
`;

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    object-fit: cover;
    line-height: 0;
    max-height: 290px;
    width: 50%;

    @media (max-width: 1640px) {
      width: 36%;
    }

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      display: flex;
      justify-content: flex-end;
      max-height: 218px;
    }
  `};
`;

export const Image = styled.img`
  ${({ $imgPosition = 'left' }) => css`
    object-fit: cover;
    object-position: ${$imgPosition};
    width: 100%;
    height: 100%;
  `}
`;

export const WrapperTagPro = styled.div`
  ${({ theme }) => css`
    left: 24px;
    position: absolute;
    top: 24px;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      left: 12px;
      top: 12px;
    }
  `}
`;

export const WrapperTitle = styled.div`
  ${() => css`
    align-items: center;
    display: flex;
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 1.5;
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 1.5;
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const CreditsTag = styled.span`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highLight};
    border-radius: 16px;
    bottom: 24px;
    color: ${theme.v2.colors.neutral.lowMedium};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 8px;
    justify-content: center;
    left: 24px;
    line-height: 1.5;
    padding: 4px 12px;
    position: absolute;
    width: fit-content;
    white-space: nowrap;

    path {
      fill: ${theme.v2.colors.neutral.lowMedium};
    }

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      bottom: 12px;
      font-size: 10px;
      left: 12px;
      padding: 4px 6px;
      gap: 4px;
    }
  `}
`;
